export const LOAN_PAID = `ההלוואה נפרעה במלואה`;